<template>
  <el-dialog
    :title="model.id ? '编辑知识库' : '新增知识库'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="700px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="small"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="model.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="设备分类" prop="item_category_id">
        <item-category-select
          :val="model.item_category_id"
          :category="2"
          @change="model.item_category_id = $event"
        ></item-category-select>
      </el-form-item>
      <el-form-item label="标签" prop="tag_names">
        <el-select
          v-model="model.tag_names"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请选择或创建标签"
          style="width: 100%"
        >
          <el-option
            v-for="item in tags"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="摘要" prop="summary">
        <el-input
          type="textarea"
          v-model="model.summary"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content" class="ql-editor-item">
        <rich-editor class="rich-editor" v-model="model.content"></rich-editor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { createRepository, updateRepository, tagList } from '@/service/getData'
import ItemCategorySelect from '@/components/select/item_category_select'
import RichEditor from '@/components/rich-editor'

export default {
  components: {
    ItemCategorySelect,
    RichEditor,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      tags: [],
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
            { size: ['small', false, 'large', 'huge'] },
            'link',
          ],
        },
      },
      visible: this.show,
      rules: {
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 150 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.getTags()
  },
  methods: {
    async getTags() {
      let res = await tagList()
      if (res.code == 0) {
        this.tags = res.data.list.map((item) => {
          return item.name
        })
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.model.item_category_id) {
            this.model.item_category_id = 0
          }
          if (this.model.id > 0) {
            let res = await updateRepository(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createRepository(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }

          this.getTags()
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style>
.ql-editor-item .el-form-item__content {
  line-height: 24px;
}
</style>

<style scoped>
/deep/.ql-editor {
  height: 150px;
}
</style>